// src/routes.tsx
import { Route } from "react-router-dom";
import appRoutes from "./routes/appRoutes";
import { RouteType }  from "./routes/config";
import { Key } from "react";

export const routes = appRoutes.map((route: RouteType, index: Key | null | undefined) => {
  if (route.index) {
    return <Route index element={route.element} key={index} />;
  }
  return <Route path={route.path} element={route.element} key={index} />;
});
